import { twMerge } from 'tailwind-merge';

import MissingPlayers from '../MissingPlayers/MissingPlayers';
import type { NationalTeamData } from './KnockoutNational.types';
import Ranking from './Ranking';
import NationalFlag from './NationalFlag';

interface NationalTeamColumnProps {
  /** National team column data (flag, ranking, optional missing players). */
  data: NationalTeamData;
  /** Localized label passed through to Ranking. */
  rankingLabel: string;
  /** Localized label passed through to MissingPlayers. */
  missingPlayersLabel: string;
  /** Optional className merged onto the column root (e.g. flex sizing from the parent). */
  className?: string;
}

export default function NationalTeamColumn({
  data,
  rankingLabel,
  missingPlayersLabel,
  className = '',
}: NationalTeamColumnProps) {
  const { flagSrc, ranking, missingPlayers = [] } = data;

  return (
    <div className={twMerge('flex flex-col gap-[4px] items-center min-w-0', className)}>
      <NationalFlag src={flagSrc} />
      <Ranking label={rankingLabel} value={ranking} />
      {missingPlayers.length > 0 && (
        <MissingPlayers label={missingPlayersLabel} players={missingPlayers} />
      )}
    </div>
  );
}
